/* eslint-disable quotes */
import './GenericHelp.scss';
import { defineComponent, h } from "vue";
import { Dialog } from '@phi/components';

const body = `<div class="summary">
    <h4 class="summary__title">Summary</h4>
    <div id="helpModalSummaryText">-</div>
</div>
<div class="default-usage">
    <h4 class="default-usage__title">Default Usage</h4>
    <div id="helpModalDefaultUsageHTML">-</div>
</div>
<div class="additional-options">
    <h4 class="additional-options__title">Additional options and tips</h4>
    <div id="helpModalAdditionalOptionsHTML">-</div>
</div>
<div class="additional-options">
    <h4 class="additional-options__title">Shortcuts</h4>
    <div id="helpModalShortcutsHTML">-</div>
</div>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            onClose: () => this.$emit('update:show', false),
            id: 'generic_help_modal',
            title: '...',
            scrollable: true,
            unload: false,
            confirm_label: null,
            width: 'narrower',
        }, () => h('div', { innerHTML: body }));
    },
});
